import gql from "graphql-tag";
const ADD_EMAILS_FOOTERS = gql `
  mutation addEmailsFooter($emailsFooterAddInput: EmailsFooterAddInput!) {
    addEmailsFooter(emailsFooterAddInput: $emailsFooterAddInput) {
      id
    }
  }
`;
export default ADD_EMAILS_FOOTERS;
